import Grid from "@components/Grid/Grid";
import RenderComponents from "@utilities/renderComponents";
import Components from "../../__Components__/Components";

export interface ClusterPageProps {
  headerBanner?: any;
  bodyContent?: any;
}

export const ClusterPage = (props: { content: ClusterPageProps }) => {
  const { content } = props;
  const { bodyContent, headerBanner } = content;

  return (
    <Grid row>
      <Grid column sm={12}>
        {headerBanner &&
          Components(
            {
              component: headerBanner.component,
              uid: headerBanner.uid,
              ...headerBanner.fields,
            },
            headerBanner.fields
          )}

        {RenderComponents(bodyContent)}
      </Grid>
    </Grid>
  );
};

export default ClusterPage;
